<template>
  <div class="SpecialOffer container_w dis_bo">
      <bread-crumb></bread-crumb>
      <page-header :headerTitle="headerTitle"></page-header>
      <!-- <nav-book></nav-book> -->
      <div v-html="detailHtml">
        
      </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader/PageHeader";
// import NavBook from "@/components/HomeComponents/HomeNav/NavBook";
import BreadCrumb from "@/components/BreadCrumb/BreadCrumb";
export default {
  components: {
    PageHeader,
    // NavBook,
    BreadCrumb
  },
  name: "SpecialOffer",
  data() {
    return {
      headerTitle:'SpecialOffer',
      detailHtml:''
    };
  },
  props: {},
  watch: {},
  methods: {},
  filters: {},
  computed: {},
  created() {
    let fileText = this.$route.query.filetext
    console.log(fileText)
    var that = this
    if (fileText) {
      this.$Ajax.get(fileText)
          .then( (response)=> {
            this.detailHtml = response.data
          })
          .catch( (error) =>{
            console.log(error);
          });
    }
  },
  mounted() {},
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less" scoped></style>
